class LoanCard {
    constructor(elem) {
        this.elem = elem;

        this.initListeners();
        this.initTooltips()
    }

    initListeners() {
        let moreBtn = this.elem.querySelector('.loan-review-card--more');

        if (moreBtn) {
            moreBtn.addEventListener('click', x => this.toggleExpanded())
        }
    }

    toggleExpanded(e) {
        if (this.elem.classList.contains('open')) {
            return this.elem.classList.remove('open')
        }

        return this.elem.classList.add('open')
    }

    initTooltips() {
        this.$tooltips = this.elem.querySelectorAll('.loan-review-card--table-cell-tooltip-trigger, .loan-review-card--table-tooltip-trigger');

        let showEvents = ['click', 'mouseenter'];
        let hideEvents = ['mouseleave'];

        this.$tooltips.forEach(x => {
            let tooltip = x.querySelector('.loan-review-card--table-cell-tooltip, .loan-review-card--table-tooltip');

            showEvents.forEach(evnt => x.addEventListener(evnt, this.show))

            hideEvents.forEach(evnt => x.addEventListener(evnt, this.hide))

            tooltip.querySelector('.loan-review-card--table-cell-tooltip-close, .loan-review-card--table-tooltip-close')
                .addEventListener('click', e => {
                    e.target.parentElement.parentElement.classList.remove('open')
                })
        })
    }

    show(e) {
        let element = e.target;
        element.classList.add('open');

    }

    hide(e) {
        let element = e.target;
        element.classList.remove('open')
    }
}

export default LoanCard;


// WEBPACK FOOTER //
// ./scripts/libs/LoanReviewCard.js